import HOCInput from 'components/common/hoc-input';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import TourHotelItem from './items/hotel';

export default function TourHotelCard() {
  const { t } = useTranslation();

  return (
    <CardSection>
      <Text variant="HeadingXSmall">
        {t('common:detail_extra', { extra: t('common:hotel') })}
      </Text>
      <HOCInput
        keys={['approvalable.tourHotels']}
        children={(value) => (
          <>
            {(value['approvalable.tourHotels'] || []).map((tf, idx) => (
              <React.Fragment key={tf.refId}>
                <Separator gap={16} direction="vertical" />
                <TourHotelItem parentIdx={idx} />
              </React.Fragment>
            ))}
          </>
        )}
      />
    </CardSection>
  );
}
